import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCommentList} from '../../../apis/comment/getCommentList'

const PAGE_SIZE = 10

const useQueryCommentList = (search_word?: string, currentPage: number = 1, search_id?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.comment.getCommentList(search_word, currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getCommentList(PAGE_SIZE, currentPage, search_word, search_id)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryCommentList
